import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.sidebar = document.getElementById("sidebar")
    this.overlay = document.getElementById("mobile-menu-overlay")
    
    // Связываем метод handleResize с контекстом
    this.handleResize = this.handleResize.bind(this)
    window.addEventListener("resize", this.handleResize)
    
    // Инициализация для мобильных устройств
    if (window.innerWidth < 1024) {
      this.closeSidebar()
    }
  }

  toggleSidebar() {
    if (this.sidebar.classList.contains("translate-x-0")) {
      this.closeSidebar()
    } else {
      this.openSidebar()
    }
  }

  openSidebar() {
    this.sidebar.classList.add("translate-x-0")
    this.overlay.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  closeSidebar() {
    this.sidebar.classList.remove("translate-x-0")
    this.overlay.classList.add("hidden")
    document.body.style.overflow = "auto"
  }

  // Закрыть сайдбар при изменении размера экрана на десктопный
  handleResize() {
    if (window.innerWidth >= 1024) {
      this.closeSidebar()
      document.body.style.overflow = "auto"
    }
  }

  disconnect() {
    window.removeEventListener("resize", this.handleResize)
    document.body.style.overflow = "auto"
  }
}
